import {AssetId} from './AssetId';


export class AssetPreview {

  constructor(assetId, thumbnailUrl) {
    this.assetId = assetId;
    this.thumbnailUrl = thumbnailUrl;
  }

  assetId = null;
  thumbnailUrl = null;

  static fromJson(payload = {} ){
    let res = new AssetPreview()
    res.assetId = AssetId.fromJson(payload.assetId)
    res.thumbnailUrl = payload.thumbnailUrl
    return res
  }

}
